import { Sidebar } from 'react-admin';
import { styled } from '@mui/material/styles';
import { Palette } from '@/themes/themeOverrides/Palette';

export const CustomSidebar = ({ open, ...rest }) => {
    return <StyledSidebar className='custom-sidebar' position='static' variant='permanent' open={open} {...rest} />;
};

const StyledSidebar = styled(Sidebar)(({ theme, open }) => ({
    '& .MuiDrawer-paper': {
        position: 'absolute',
        height: 'calc(100vh - 60px)',
        marginTop: '60px',
        backgroundColor: Palette.white,
        width: '100vw',
        zIndex: theme.zIndex.drawer,
        transform: open ? 'translateX(0)' : 'translateX(-100%)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        [theme.breakpoints.up('md')]: {
            position: 'static',
            height: '100%',
            marginTop: 0,
            width: 'auto',
            maxWidth: '260px',
            transform: 'none',
            '& .RaMenu-closed': {
                display: 'block !important',
            },
        },
        [theme.breakpoints.up('lg')]: {
            '& .toggle-menu-button': {
                display: 'block',
            },
        },
    },
    '& .toggle-menu-button': {
        display: 'none',
    },
    '& .RaSidebar-fixed': {
        width: '100% !important',
        display: 'block !important',
    },
    '& .RaMenu-open, & .RaMenu-closed': {
        display: 'block !important',
    },
}));
